<template>
  <transition
    name="expand"
    appear=""
  >
    <div
      v-if="flash.message || flash.template || !isDefaultSlotEmpty"
      :class="['wizard-flash-message', flash.status]"
      :style="{ borderRadius: flash.borderRadius }"
    >
      <DpplSvg
        v-if="icon"
        class="icon ml-auto mr-4 my-auto"
        :file-name="icon"
      />
      <p
        class="message mx-auto"
      >
        <slot>
          <UserExistsTemplate v-if="flash.template === 'user-exists'" />
          <UserActiveTemplate v-else-if="flash.template === 'user-active'" />
          <ContactUsTemplate v-else-if="flash.template === 'contact-us'" />
          <ExceededTriesTemplate v-else-if="flash.template === 'exceeded-tries'" />
          <IncorrectEmailOrPasswordTemplate
            v-else-if="flash.template === 'incorrect-email-or-password'"
          />
          <span v-else>{{ flash.message }}</span>
        </slot>
      </p>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';
import UserExistsTemplate from '@/components/shared/FlashMessageTemplates/UserExistsTemplate.vue';
import UserActiveTemplate from '@/components/shared/FlashMessageTemplates/UserActiveTemplate.vue';
import ContactUsTemplate from '@/components/shared/FlashMessageTemplates/ContactUsTemplate.vue';
import ExceededTriesTemplate from '@/components/shared/FlashMessageTemplates/ExceededTriesTemplate.vue';
import IncorrectEmailOrPasswordTemplate from '@/components/shared/FlashMessageTemplates/IncorrectEmailOrPasswordTemplate.vue';
import { isSlotEmpty } from '@/helpers/slotsChecker';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

/* eslint-disable global-require */
export default {
  name: 'WizardFlashMessage',
  components: {
    UserExistsTemplate,
    UserActiveTemplate,
    ContactUsTemplate,
    ExceededTriesTemplate,
    IncorrectEmailOrPasswordTemplate,
    DpplSvg,
  },
  computed: {
    ...mapState(useWizard, ['flash']),
    isDefaultSlotEmpty() {
      if (!this.$slots.default) return true;
      return isSlotEmpty(this.$slots.default());
    },
    icon() {
      const map = {
        success: 'icons/icon-check-circle-green',
        error: 'icons/icon-exclaimation-circle-red',
        warning: 'icon-exclamation-mark',
      };

      return map[this.flash.status];
    },
  },
  beforeUnmount() {
    this.resetFlash();
  },
  methods: {
    ...mapActions(useWizard, ['resetFlash']),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .v-application .wizard-flash-message.success {
    background-color: @bg-success-light!important;
  }
  .v-application .wizard-flash-message.error {
    background-color: @bg-error-light!important;
  }
  .v-application .wizard-flash-message.warning {
    background-color: @bg-warning-light!important;
  }
  .v-application .wizard-flash-message.success :deep(a) {
    color: @basic-green;
  }
  .v-application .wizard-flash-message.warning :deep(a) {
    color: @basic-yellow;
  }
  .v-application .wizard-flash-message.error :deep(a),
  .v-application .wizard-flash-message.error :deep(#resend) {
    color: @basic-red;
  }
  .wizard-flash-message {
    display: flex;
    flex-direction: row;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 26px;
    padding-right: 26px;
    width: 100%;
  }

/* always present */
.expand-enter-active {
  transition: all .3s ease;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter, .expand-leave-to {
  height: 0;
  padding: 0;
  opacity: 0;
}

.wizard-flash-message .message :deep(h5) {
  text-align: center;
  margin: 0;
  display: inline;
}
</style>
